<template>
    <div class="dgth-container">
        <display-header v-bind:loaded="this.loaded" />
        <full-calendar
            :events="getEvents"
            :config="config"
            class="dgth-calendar"
            ref="calendar"
        >
        </full-calendar>
        <display-events/>
    </div>
</template>

<script>
    import { FullCalendar } from 'vue-full-calendar';
    import DisplayEvents from './components/DisplayEvents';
    import DisplayHeader from './components/DisplayHeader';
    import 'fullcalendar/dist/fullcalendar.css';
    import interactionPlugin from '@fullcalendar/interaction';
    import moment from 'moment';
    import srLocale from 'fullcalendar/dist/locale/sr';
    import srCyrLocale from 'fullcalendar/dist/locale/sr-cyrl';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'dgth-calendar',
        locales: [srLocale, srCyrLocale],
        calendarPlugins: [interactionPlugin],
        components: {
            FullCalendar,
            DisplayEvents,
            DisplayHeader
        },
        data () {
            return {
                loaded: false,
                config: {
                    defaultView: 'month',
                    selectable: true,
                    eventLimit: true,
                    views: {
                        timeGrid: {
                            eventLimit: 0 // adjust to 6 only for timeGridWeek/timeGridDay
                        }
                    },
                    header: {
                        right: '',
                    },
                    dayClick: (date) => {
                        this.handleDayClick(date);
                    }
                },
            }
        },
        created() {
            this.fetchEvents().then(() => {
                this.loaded = true;
            });
        },
        updated() {

        },
        methods: {
            handleDayClick(date) {
                let clickedEvents = this.getEvents.find((ev) => { return moment(ev.start).isSame(date._d, 'day'); });
                let selectedDay = {};

                if (clickedEvents) {
                    selectedDay.title = moment(clickedEvents.start).format('D.M.YYYY - dddd');
                    selectedDay.data = clickedEvents.extenderProps.events;
                    this.setSelectedDay(selectedDay);
                } else {
                    this.setSelectedDay({});
                }
            },
            ...mapActions([
                'fetchEvents',
                'setSelectedDay'
            ])
        },
        computed: {
            ...mapGetters([
                'getEvents'
            ])
        }
    }
</script>

<style lang="scss">
    $green: #77ae37;
    $blue: #48649e;

    .dgth-container {
        position: relative;
    }

    #calendar { //TODO Add only absolute positioning if .fc-basic-view is on. Remove when day / week mode is on

        &.dgth-calendar {

            .fc-row.fc-rigid .fc-content-skeleton {
                bottom: 0;

                table {
                    position: relative;
                }
            }

            .fc .fc-row .fc-content-skeleton table,
            .fc .fc-row .fc-content-skeleton td,
            .fc .fc-row .fc-helper-skeleton td {
                height: 100%;
            }

            .fc-event,
            .fc-event-dot {
                background: $green;
            }

            .fc-head {

                thead {
                    background: $blue;
                    color: #fff;

                    th {
                        padding: 10px 0;
                        border: 0;
                    }
                }
            }

            .fc-body {

                thead {

                    .fc-day-number {

                    }

                    td {
                        position: relative;
                        border-width: 0;
                    }

                    tr {
                        height: 57px;
                    }

                    @media (min-width: 768px) {

                        tr {
                            height: 60px;
                        }
                    }

                    @media (min-width: 992px) {

                        tr {
                            height: 73px;
                        }
                    }

                    @media (min-width: 1300px) {

                        tr {
                            height: 99px;
                        }

                        td {

                            .fc-day-number {
                                position: absolute;
                                top: 36px; left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                    }
                }

                tbody {

                    .fc-event-container {
                        position: relative;
                        pointer-events: none;

                        .fc-event {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0;
                            padding: 2px 0 0;
                            width: 22px; height: 22px;
                            background: $green;
                            border-radius: 50%;
                            font-weight: 600;
                            border: 0;
                            font-size: 12px;
                            box-sizing: border-box;
                        }
                    }
                }
            }

            .fc-basic-view {

                .fc-body {

                    tbody {

                        .fc-event-container {

                            .fc-event {
                                position: absolute;
                                right: 5px; bottom: 5px;

                                @media (min-width: 768px) {
                                    right: 8px; bottom: 10px;
                                }
                            }
                        }
                    }
                }
            }

            .fc-toolbar.fc-header-toolbar {
                position: relative;
                margin-bottom: 230px;

                @media (min-width: 768px) {
                    margin-bottom: 140px;
                }

                .fc-center {
                    text-transform: capitalize;

                    h2 {
                        font-size: 20px;
                    }
                }

                .fc-left {
                    position: absolute;
                    top: calc(50% - 3px); left: 50%;
                    transform: translate(-50%, -50%);
                    pointer-events: none;

                    .fc-button-group {
                        display: flex;
                        justify-content: space-between;
                        margin: 0;
                        width: 280px;
                        pointer-events: none;

                        & > button {
                            pointer-events: all;
                            margin: 0;
                            border: 0;
                            background: transparent;
                            box-shadow: none;
                        }
                    }

                    .fc-today-button {
                        position: absolute;
                        margin: 0;
                        left: 50%; top: calc(100% + 10px);
                        transform: translateX(-50%);
                        pointer-events: all;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue